import axios from "./Axios";

// Action Types
export const FETCH_API_KEYS_SUCCESS = "FETCH_API_KEYS_SUCCESS";
export const FETCH_API_KEYS_FAIL = "FETCH_API_KEYS_FAIL";
export const CREATE_API_KEY_SUCCESS = "CREATE_API_KEY_SUCCESS";
export const CREATE_API_KEY_FAIL = "CREATE_API_KEY_FAIL";
export const DELETE_API_KEY_SUCCESS = "DELETE_API_KEY_SUCCESS";
export const DELETE_API_KEY_FAIL = "DELETE_API_KEY_FAIL";

// Fetch all API keys for the user
export const FetchAPIKeysAction = () => async (dispatch) => {
  try {
    const response = await axios.get(`/api/userauth/api-keys/`);

    dispatch({
      type: FETCH_API_KEYS_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_API_KEYS_FAIL,
      payload: error.response?.data || { error: "Failed to fetch API keys" },
    });
    throw error;
  }
};

// Create a new API key
export const CreateAPIKeyAction = (name, expiresAt = null) => async (dispatch) => {
  try {
    const data = {
      name,
      expires_at: expiresAt,
    };

    const response = await axios.post(`/api/userauth/api-keys/`, data);

    dispatch({
      type: CREATE_API_KEY_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_API_KEY_FAIL,
      payload: error.response?.data || { error: "Failed to create API key" },
    });
    throw error;
  }
};

// Delete an API key
export const DeleteAPIKeyAction = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/userauth/api-keys/${id}/`);

    dispatch({
      type: DELETE_API_KEY_SUCCESS,
      payload: id,
    });

    return id;
  } catch (error) {
    dispatch({
      type: DELETE_API_KEY_FAIL,
      payload: error.response?.data || { error: "Failed to delete API key" },
    });
    throw error;
  }
};
